import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as adminActions from '../admin/redux/actions';
import { Input, Row, Col, List, message, Transfer, Button, Tabs, Card, Select, Table, Tag, Icon } from 'antd'
import { Page, Crud } from '../../components'
const { CrudTable, CrudForm, CrudFilter, CrudButtons } = Crud
const { TabPane } = Tabs;
const Option = Select.Option;

export class PositionCategory extends Component {
  static propTypes = {
    system: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };


  constructor(props) {
    super(props)
    this.state = {
      targetKeys: [],
      curCategoryPositions: [], //当前栏目下职位
      transList: [], //穿梭数据源
      curCategoryId: 0,//当前编辑的栏目
      curEditTag: 0,//当前正添加的tag
    };
    this.curPositionTypeId = 0; // 当前正编辑的职位类型id
    this.companyPositionPage = 1;
  }



  componentDidMount() {
    const { system } = this.props;
    const { getPositionCategory, getAllChildPostion, getPositionTypeList } = this.props.actions;
    const { getDicList } = this.props.adminActions;
    //console.log('getPositionCategory');
    getPositionCategory();
    getPositionTypeList({ page: 1, size: 10 });
    getAllChildPostion()
    getDicList('positiontag');
    // console.log('getPositionCategory');
  }


  get filterProps() {
    return {
      title: "",
      searchElements: [
        {
          key: "typeName",
          widget: Input,
          widgetProps: {
            placeholder: "职位名称"
          },
        },
        {
          key: "tags",
          widget: Select,
          widgetProps: {
            placeholder: "选择职位属性",
            style: {
              width: '200px',
            }
          },
          children: this.getTags(),
        }
      ],
      onFilterChange: value => {
        console.log('onFilterChange', value);
        // this.companyName = value.companyName
        // this.areaId = value.areaId
        // this.userName = value.userName
        // this.userPhone = value.userPhone
        // this.isAuth = value.isAuth
        this.fetchList(1 , value);
      },
      onAdd() {

      },
    }
  }

  getAddTags = () => {
    const { admin } = this.props;
    const { dicTypes } = admin;

    // console.log('dicTypes', dicTypes['positiontag']);
    //console.log('dicTypes', dicTypes);
    let arr = dicTypes['positiontag'];
    console.log('dicTypes---------------');
    console.log(arr);
    let btns = [];
    if (arr) {
      arr.map(item => {
        btns.push(<Option key={item.id} >{item.tag}</Option>)
      })
    } else {
      console.log('加载数据中');
    }

    return btns;
  }
  getTags = () => {
    const { admin } = this.props;
    const { dicTypes } = admin;
    // console.log('dicTypes', dicTypes['positiontag']);
    //console.log('dicTypes', dicTypes);
    let arr = dicTypes['positiontag'];
    console.log('dicTypes---------------');
    console.log(arr);
    let btns = [];
    if (arr) {
      arr.map(item => {
        btns.push(<Option key={item.id} >{item.tag} </Option>)
      })
    } else {
      console.log('加载数据中');
    }



    return btns;
  }


  // <CrudButtons {...this.buttonProps} />
  // <CrudFilter {...this.filterProps} />

  render() {

    const { positionCategoyList, allChildPositionList } = this.props.system;



    return (<Page inner><Tabs defaultActiveKey="1">
      <TabPane tab="全部职位" key="1">
        <CrudFilter {...this.filterProps} />
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />

        <CrudForm {...this.modalProps} />
        <CrudForm {...this.modalPropss} />
        <CrudForm {...this.tempmodalProps} />





      </TabPane>
      <TabPane tab="职位栏目" key="2">
        <Row>
          <Col span={4}>
            <div style={{ paddingRight: 10 }}>

              <List
                header={<div style={{ fontSize: 20 }}>职位栏目</div>}
                itemLayout="horizontal"
                bordered
                dataSource={positionCategoyList}
                renderItem={item => (
                  <List.Item
                    actions={[<a key="list-loadmore-edit" onClick={(e) => this.handleEditCategory(item)}>编辑</a>]}
                  >
                    <List.Item.Meta
                      title={item.name}
                      description={item.id == this.state.curCategoryId ? '正在编辑' : ''}
                    />
                  </List.Item>
                )}
              />
            </div>
          </Col>
          <Col span={20} >



            <Transfer
              listStyle={{
                width: 500,
                height: 800,
              }}
              showSearch
              dataSource={allChildPositionList}
              titles={['全部职位', '已选职位']}
              filterOption={this.filterOption}
              targetKeys={this.state.targetKeys}
              onChange={this.handleChange}
              onSearch={this.handleSearch}
              render={item => item.typeName}
            />
          </Col>
        </Row>

      </TabPane>
      <TabPane tab="职位栏目列表" key="3">
        <CrudButtons {...this.buttonPropss} />
        <CrudTable {...this.listPropss} />

        <CrudForm {...this.tagmodalProps} />


      </TabPane>
    </Tabs></Page>);
  }


  handleEditCategory = (item) => {
    const { getPositionListwithCaterogy } = this.props.actions;
    this.setState({
      curCategoryId: item.id
    })
    console.log('handleEditCategory', item);
    getPositionListwithCaterogy({ category_id: item.id }).then(res => {
      console.log('getPositionListwithCaterogy', res);
      let tags = []
      res.map(item => {
        tags.push(item.id)
      })

      this.setState({
        targetKeys: tags
      })

    }).catch(msg => {

    });
  }
  handleAddTags = (item) => {
    const { getPositionListwithCaterogy } = this.props.actions;
    this.setState({
      curEditTag: item.id
    })
    //console.log('handleEditCategory', item);
    getPositionListwithCaterogy({ category_id: item.id }).then(res => {
      console.log('getPositionListwithCaterogy', res);
      let tags = []
      res.map(item => {
        tags.push(item.id)
      })

      this.setState({
        targetKeys: tags
      })

    }).catch(msg => {

    });
  }

  filterOption(inputValue, option) {
    return option.typeName.indexOf(inputValue) > -1
  }
  get buttonProps() {
    const { actions } = this.props

    const { companyPositionModalChange } = actions;

    return {
      buttons: [
        {
          name: "新增",
          buttonProps: {
            type: "primary",
            icon: "plus",
          },
          onClick: () => { companyPositionModalChange(true, 'create') }
        }
      ]
    }
  }

  get buttonPropss() {
    const { actions } = this.props

    const { companyPositionListModalChange } = actions;

    return {
      buttons: [
        {
          name: "新增",
          buttonProps: {
            type: "primary",
            icon: "plus",
          },
          onClick: () => { companyPositionListModalChange(true) }
        }
      ]
    }
  }
  fetchList = (page, values) => {
    // console.log('fetchList' , page)

    const { getPositionTypeList } = this.props.actions;
    let params = Object.assign({}, { page: page, size: 10 }, values);
    getPositionTypeList(params);
  }

  fetchLists = (page) => {
    // console.log('fetchList' , page)

    const { getPositionCategory } = this.props.actions;
    let params = Object.assign({}, { page: page, size: 10 });
    getPositionCategory(params);
  }
  tagfetchList = (page) => {
    // console.log('fetchList' , page)

    const { getPositionCategory } = this.props.actions;
    // let params = Object.assign({},{page:page});
    getPositionCategory();
  }


  editTemplate = (params1, params2) => {
    const { templateModalChange, chooseCuTemplate } = this.props.actions;
    chooseCuTemplate(params1);
    templateModalChange(true, params2);

  }

  getExpandRowRender = (record) => {

    let templates = record.templates || [];
    if (templates.length == 0) {
      return <div ><Card><Icon type="plus" key="plus" style={{ fontSize: 22 }} onClick={(e) => this.editTemplate({ id: record.id }, 'create')} /></Card></div>
    }
    return <div >
      <Row gutter={16}>
        {templates.map(item => {
          return <Col span={8}><Card title={item.name} style={{ textAlign: "left" }}><p >{item.desc}</p>
            <p>{item.content}</p>

            <Icon type="edit" key="edit" style={{ fontSize: 22 }} onClick={(e) => this.editTemplate(item, 'update')} />

          </Card></Col>
        })}
        <Icon type="plus" key="plus" style={{ fontSize: 22 }} onClick={(e) => this.editTemplate({ id: record.id }, 'create')} />
      </Row></div>
  }

  deleteTag = (params) => {
    console.log('删除啦');
    const { submitdelTag } = this.props.actions;
    submitdelTag({ id: params })
    this.fetchList(this.companyPositionPage);
  }

  //  <Icon onClick= { tagssModalChange(true,item.id) }  type="close-circle" />

  get listProps() {
    const { system, actions } = this.props
    const { getPositionTypeListPending, positionTypeList, positionTypePage, positionTypeTotal, positionTypeById } = system
    const { chooseCurrentCompanyPositionNameType, companyPositionModalChange, tagModalChange, tagssModalChange } = actions;

    let list = [];
    for (var key in positionTypeById) {
      list.push(positionTypeById[key]);
    }

    return {
      dataSource: list,
      loading: getPositionTypeListPending,
      expandedRowRender: this.getExpandRowRender,
      columns: [
        {
          title: "职位名称",
          dataIndex: 'typeName',
          key: 'typeName',
          width: 180,
        },
        {
          title: "排序号",
          dataIndex: 'orderNum',
          key: 'orderNum',

          width: 180,
        },
        {
          title: "Tags",
          dataIndex: 'tags',
          key: 'tags',
          render: (record, index) => {
            return <div>
              {record.map(item => {
                return <Tag closable={false}>


                  {item.tag_value}
                  <Icon onClick={() => this.deleteTag(item.id)} type="close-circle" />
                </Tag>
              })}
            </div>
          },
          width: 180,
          style: {
            height: 40
          }
        },
      ],
      pagination: {
        total: positionTypeTotal,
        current: positionTypePage,
        onChange: (page) => {
          this.companyPositionPage = page;
          this.fetchList(page);
        }
      },
      op: [
        {
          key: 1,
          name: '编辑',
          buttonProps: {
            icon: "edit",
            type: "primary"
          },
        },
        {
          key: 2,
          name: 'addTags',
          buttonProps: {
            icon: "plus",
            type: "primary"
          }

        },

      ],
      handleMenuClick: (record, item) => {
        if (item.key == 1) {
          chooseCurrentCompanyPositionNameType(record);
          companyPositionModalChange(true, "updata");
        } else if (item.key == 2) {//增加属性
          this.curPositionTypeId = record.id;
          tagModalChange({ visible: true })
          this.getAddTags();
        }
      }
    }
  }

  get listPropss() {
    const { system, actions } = this.props;
    const { positionCategoyList, getPositionCategoryPending, positionCategoryTotal, positionCategoryPage } = system;
    const { companyPositionListModalChange, chooseCurrentCompanyPositionList } = actions;


    return {
      dataSource: positionCategoyList,
      loading: getPositionCategoryPending,
      columns: [
        {
          title: "职位栏目名称",
          dataIndex: 'name',
          key: 'name',
          width: 180,
        },
        {
          title: "type",
          dataIndex: 'type',
          key: 'type',
          align: 'left',
          width: 180,
        },
        {
          title: "排序号",
          dataIndex: 'orderNum',
          key: 'orderNum',
          align: 'left',
          width: 180,
        },

      ],
      pagination: null,
      op: [
        {
          key: 1,
          name: '编辑',
          buttonProps: {
            icon: "edit",
            type: "primary"
          },
        },


      ],
      handleMenuClick: (record, item) => {
        if (item.key == 1) {
          chooseCurrentCompanyPositionList(record);
          companyPositionListModalChange(true)
        }
      }
    }
  }
  /**
* 确认是否删除标签
*/
  get confirmTagmodalProps() {
    const { system, actions } = this.props;
    const { tagssModalVisible, submitdelTagPending, } = system;
    const { submitdelTag, tagssModalChange } = actions;
    return {
      title: '确认删除标签吗',
      visible: tagssModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitdelTagPending,
      onOk: data => {
        // submitdelTag(Object.assign({}, data)).then(data => {

        //   tagssModalChange(false);
        //   this.fetchList(this.companyPositionPage);
        // }
        // )
      },
      onCancel() {
        tagssModalChange(false);
      },
    }
  }
  /**
  * 新增或编辑职位模板
  */
  get tempmodalProps() {
    const { system, actions } = this.props;
    const { tagssModalVisible, cuPositionTempListName, submittempListPending, addTagModalType } = system;
    const { TextArea } = Input;

    const { templateModalChange, submitTemplateModifyType } = actions;
    const editItem = cuPositionTempListName || [];
    console.log('editItem=====模板' + editItem);
    return {
      item: addTagModalType === 'create' ? {} : cuPositionTempListName,
      visible: tagssModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submittempListPending,
      title: `${
      addTagModalType === 'create' ? '新增模板' : '编辑模板'
      }`,

      centered: true,
      elements: [
        {
          key: "name",
          label: "模板名称",
          initialValue: editItem.name,
          widget: Input,
          required: true
        },
        {
          key: "desc",
          label: "模板描述",
          initialValue: editItem.desc,
          widget: Input,
          required: true
        },
        {
          key: "content",
          label: "模板征文",
          initialValue: editItem.content,
          widget: TextArea,
          required: true
        },
        {
          key: "position_id",
          label: "",
          initialValue: editItem.position_id || editItem.id,
          widget: Input,
          type: 'hidden'
        },
        {
          key: "category_id",
          label: "",
          initialValue: editItem.category_id || 1,
          widget: Input,
          type: 'hidden'
        },

      ],
      onOk: data => {
        submitTemplateModifyType(Object.assign({}, data)).then(data => {

          templateModalChange(false, 'create');
          this.fetchList(this.companyPositionPage);
        })
      },
      onCancel() {
        templateModalChange(false, 'create');
      },
    }
  }

  /**
  * 全部职位里新增或编辑职位名称
  */
  get modalProps() {
    const { system, actions } = this.props
    const { companyPositionModalVisible, companyPositionModalType, submitCompanyPositionPending, currentCompanyPositionName } = system

    const { companyPositionModalChange, submitPositionNameType } = actions;
    const editItem = companyPositionModalType === 'create' ? {} : currentCompanyPositionName
    return {
      item: companyPositionModalType === 'create' ? {} : currentCompanyPositionName,
      visible: companyPositionModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitCompanyPositionPending,
      title: `${
      companyPositionModalType === 'create' ? `新增` : `编辑`
      }`,
      centered: true,
      elements: [
        {
          key: "typeName",
          label: "职位名称",
          initialValue: editItem.typeName,
          widget: Input,
          required: true
        },
        {
          key: "orderNum",
          label: "排序号",
          initialValue: editItem.orderNum,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitPositionNameType(Object.assign({}, data, { pid: 1 })).then(data => {

          companyPositionModalChange(false, "create");
          this.fetchList(this.companyPositionPage);
        })
      },
      onCancel: () => {
        companyPositionModalChange(false, "create");
      },
    }
  }
  /**
   * 全部职位里增加属性
   */
  get modalPropss() {
    const { system, actions } = this.props
    const { submittagsPending, tagModalVisible, companyPositionPage } = system

    const { tagModalChange, addCurrentTags, chooseCurrentCompanyPositionNameType } = actions;
    const { admin } = this.props;
    const { dicTypes } = admin;
    // console.log('dicTypes', dicTypes['positiontag']);
    //console.log('dicTypes', dicTypes);

    let arr = dicTypes['positiontag'];
    let btns = [];
    //let taglist=[];
    if (arr) {
      arr.map(item => {
        btns.push({ id: item.id, value: item.tag })
      })
    } else {
      console.log('加载数据中');
    }
    const editItem = { tags: btns };

    //taglist =editItem.tags;
    return {
      item: editItem,
      visible: tagModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submittagsPending,
      title: '选择属性',
      centered: true,
      elements: [{
        key: "tag_id",
        label: "添加属性",
        // initialValue: editItem.tags,
        widget: Select,

        widgetProps: {
          mode: "multiple",
        },
        children: this.getAddTags(),
        required: true
      }],
      onOk: data => {
        console.log('xyx--------------------');
        console.log(data);
        let ids = data.tag_id;
        let vas = []
        ids.map(item => {
          arr.map(a => {
            if (a.id == item) {
              vas.push(a.tag)
            }
          })
        })
        console.log('vas', vas);

        //this.fetchAnoArr();
        let params = { position_type_id: this.curPositionTypeId, tag_value: vas.join(';'), tag_id: ids.join(';') }
        addCurrentTags(Object.assign({}, data, params)).then(data => {

          tagModalChange(false)
          this.fetchList(this.companyPositionPage);
        })
      },
      onCancel() {
        tagModalChange(false)
      },
    }
  }


  /**
   * 职位栏目列表新增或编辑
   */
  get tagmodalProps() {
    const { system, actions } = this.props;
    const { companyPositionListModalType, companyPositionListModalVisible, cuCompanyPositionListName, submitPositionListTypePending, coPositionListPage } = system

    const { companyPositionListModalChange, submitPositionListType } = actions;
    const editItem = companyPositionListModalType === 'create' ? {} : cuCompanyPositionListName
    return {
      item: companyPositionListModalType === 'create' ? {} : cuCompanyPositionListName,
      visible: companyPositionListModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitPositionListTypePending,
      title: `${
      companyPositionListModalType === 'create' ? `新增` : `编辑`
      }`,
      centered: true,
      elements: [
        {
          key: "name",
          label: "栏目列表名称",
          initialValue: editItem.name,
          widget: Input,
          required: true
        },
        {
          key: "type",
          label: "type",
          initialValue: editItem.type,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitPositionListType(Object.assign({}, data)).then(data => {

          companyPositionListModalChange(false, "create");
          this.tagfetchList(coPositionListPage);
        })
      },
      onCancel: () => {
        companyPositionListModalChange(false, "create");
      },
    }
  }

  handleChange = (targetKeys, direction, moveKeys) => {
    const { addCategoryChildPosition, removeCategoryChildPosition } = this.props.actions;
    console.log('handleChange', targetKeys);
    console.log('handleChange', direction);
    console.log('moveKeys', moveKeys)
    // let ids = [];
    // targetKeys.map(item => {
    //   ids.push(item.id);
    // })
    if (direction === 'right') {
      // 添加
      addCategoryChildPosition({ cid: this.state.curCategoryId, pid: targetKeys.join(';') }).then(res => {
        this.setState({ targetKeys });
      })
    } else {
      // 移除
      removeCategoryChildPosition({ cid: this.state.curCategoryId, id: moveKeys.join(';') }).then(res => {
        this.setState({ targetKeys });
      })
    }

  };

  handleSearch = (dir, value) => {
    console.log('search:', dir, value);
  };
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    system: state.system,
    admin: state.admin
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    adminActions: bindActionCreators({ ...adminActions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PositionCategory);



// WEBPACK FOOTER //
// ./src/features/system/PositionCategory.js